import config from "./config.json";
export const { serverPath, SITE_KEY, siteLogoutTime, monoLanguage, clientPath } =
  config[process.env.REACT_APP_NODE_ENV];
